import { z } from "zod";
import {
  CookLogApiItemSchema,
  CookLogListResponseSchema,
  PatchCookLogRequestSchema,
  type CookLogApiItem,
  type CookLogListResponse,
  type PatchCookLogRequest,
} from "@recipevault/shared";
import { apiGet, apiPatch, apiDelete } from "../../shared/http.js";

const CookLogEnvelope = z.object({ cookLog: CookLogApiItemSchema });

/** GET /recipes/{recipeId}/cook-logs — newest cook first; soft-deleted rows are already filtered server-side. */
export async function getCookLogsByRecipe(
  recipeId: string,
  cursor?: string,
): Promise<CookLogListResponse> {
  const qs = cursor ? `?cursor=${encodeURIComponent(cursor)}` : "";
  const raw = await apiGet<unknown>(`/recipes/${recipeId}/cook-logs${qs}`);
  return CookLogListResponseSchema.parse(raw);
}

/** PATCH /cook-logs/{logId} — body must carry completedAt (the SK prefix) + ≥1 editable field. */
export async function patchCookLog(
  logId: string,
  body: PatchCookLogRequest,
): Promise<CookLogApiItem> {
  PatchCookLogRequestSchema.parse(body);
  const raw = await apiPatch<unknown>(`/cook-logs/${logId}`, body);
  return CookLogEnvelope.parse(raw).cookLog;
}

/** DELETE /cook-logs/{logId}?completedAt= — soft delete; idempotent (204). */
export async function deleteCookLog(logId: string, completedAt: string): Promise<void> {
  await apiDelete<unknown>(`/cook-logs/${logId}?completedAt=${encodeURIComponent(completedAt)}`);
}
